import { get, find } from "lodash";

const CURRENCIES = [
  { value: "USD", label: "USD", unit: "$" },
  { value: "EUR", label: "EUR", unit: "€" },
  { value: "BTC", label: "BTC", unit: "฿" }
];

export const getCountDecimals = (value = 0, fallback = 0) => {
  const decimals = value.toString().split(".")[1];

  if (decimals) {
    return decimals.length;
  }

  return fallback || 0;
};

export const money = (amount, locales, options) => {
  const formatter = new Intl.NumberFormat(locales, {
    style: "currency",
    minimumFractionDigits: 2,
    ...options
  });
  return formatter.format(amount);
};

export const getCurrencySymbol = (currency) => {
  const current = find(CURRENCIES, { value: currency });

  return get(current, "unit");
};



// WEBPACK FOOTER //
// ./src/utils/currencyHelper.js